<template>
  <div>
    <video :src="video_url" ref="video" width="360" type="video/mpeg"></video>
    <vue-wave-surfer :src="video_url" :options="wavesurfer_options" ref='wavesurfer' class='mb-2'></vue-wave-surfer>

    <b-row>
      <b-col>
        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
          <b-button-group class="mx-1">
            <b-button @click="play()" v-if="!playing" key="play" ><i class="fas fa-play" ></i></b-button>
            <b-button @click="pause()" v-else key="pause"><i class="fas fa-pause" ></i></b-button>
          </b-button-group>
          <b-button-group class="mx-1">
            <b-button @click="zoom(+50)"><i class='fas fa-search-plus' /></b-button>
            <b-button @click="zoom(-50)"><i class='fas fa-search-minus' /></b-button>
          </b-button-group>
          <b-button-group class="mx-1">
            <b-button variant="transparent">{{timestamp.toFixed(2)}}</b-button>
          </b-button-group>
        </b-button-toolbar>
      </b-col>
      <b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Wavesurfer from "@/components/Wavesurfer.vue"
import Cursor from "wavesurfer.js/dist/plugin/wavesurfer.cursor"
import Regions from "wavesurfer.js/dist/plugin/wavesurfer.regions"

export default {
  props: ['video_url'],
  components: {'vue-wave-surfer': Wavesurfer},
  data() {
    return {
      timestamp: 0,
      zoom_level: 150,
      surfer: null,
      playing: false,
      wavesurfer_options: {
        height: 100,
        waveColor: '#D9DCFF',
        progressColor: '#4353FF',
        cursorColor: '#4353FF',
        // barWidth: 1,
        barRadius: 3,
        cursorWidth: 1,
        barGap: 3,
        pixelRatio: 1,
        minPxPerSec: 150,
        scrollParent: true,
        normalize: true,
        splitChannels: false,
        backend: 'MediaElement',
        plugins: [
           Regions.create(),
           Cursor.create()
       ]
      },
    }
  },
  methods: {
    update_time() {
      if (this.surfer) {
        this.timestamp = this.surfer.getCurrentTime()
      } else {
        this.timestamp = 0
      }
    },
    zoom(direction) {
      this.zoom_level += direction
      if (this.zoom_level > 1000) {
        this.zoom_level = 10
      }
      if (this.zoom_level < 0) {
        this.zoom_level = 0
      }

      this.surfer.zoom(Number(this.zoom_level));
    },
    play(seek_time) {
      this.playing = true
      this.surfer.play(seek_time)
      this.region_click = false
    },
    pause() {
      this.playing = false
      this.surfer.pause()
      this.region_click = false
    },
    goto(seek_time) {
      this.play(seek_time)
      this.pause()
      // this.region_click = true
    },
    randomColor(alpha) {
      return (
          'rgba(' +
          [
              ~~(Math.random() * 255),
              ~~(Math.random() * 255),
              ~~(Math.random() * 255),
              alpha || 1
          ] +
          ')'
      )
    },
  },
  mounted() {
    if (this.$refs.wavesurfer && !this.surfer) {
      this.surfer = this.$refs.wavesurfer.waveSurfer

      var mediaElt = this.$refs.video
      this.surfer.load(mediaElt)

      this.surfer.on('seek', this.update_time)
      this.surfer.on('ready', this.update_time)
      this.surfer.on('audioprocess', this.update_time)
      /* Toggle play/pause buttons. */
      this.surfer.on('play', function() {
          this.playing = true
      }.bind(this))
      this.surfer.on('pause', function() {
          this.playing = false
      }.bind(this))
    }
  },
};
</script>

<style lang="css" scoped>

</style>
